import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'
import { OK } from 'http-status-codes'

class PreIngresoCalado {
  static consultaPorCalle (calle) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cpa_admisible_para_cea?r=` +
          `{"clave": {"calle_de_ingreso": "${calle}"},` +
          `"limite":1, "orden": ["fecha_de_ingreso"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static cargaPreIngresoCalado (numero, calle) {
    const axios = getAxiosInstance()
    const promise = axios.get(`dar_alta_cpa_preingreso_calado?r=` +
      `{"parametros": {"nro_de_ctge": "${numero}", "calle_de_ingreso": "${calle}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }

  static obtenerFoto (numero, calle) {
    const axios = getAxiosInstance()
    const promise = axios.get(`obtener_foto_preingreso_calado?r=` +
      `{"parametros": {"nro_de_ctge": "${numero}", "calle_de_ingreso": "${calle}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }

  static vaciarCallePreIngresoCalado (calle) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`vista_preingreso_a_calado?r=` +
      `{"clave": {"calle_de_ingreso": ${calle}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static eliminarCallePreIngresoPorNumero (numero) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`preingreso_calado?r=` +
     `{"clave": {"nro_ctge": ${numero}}}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('Error.')
      return data
    })
  }

  static consultaEstadoCallePreingresoCalado (calle) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cpa_admisible_para_cea?r=` +
    `{"clave": {"calle_de_ingreso": "${calle}"},` +
    `"limite":1, "orden": ["d:fecha_de_ingreso"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static encender12 () {
    const axios = getAxiosInstance()
    const promise = axios.get(`encender12`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }

  static encender34 () {
    const axios = getAxiosInstance()
    const promise = axios.get(`encender34`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }

  static apagar12 () {
    const axios = getAxiosInstance()
    const promise = axios.get(`apagar12`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }

  static apagar34 () {
    const axios = getAxiosInstance()
    const promise = axios.get(`apagar34`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }
}

export default PreIngresoCalado
